import { useField } from "formik";
import { InputControl, InputControlProps } from "formik-chakra-ui";
import { Ref } from "react";

/**
 * This is a workaround for formik-chakra-ui type limitation:
 * https://github.com/thekaganugur/formik-chakra-ui/issues/106
 */
export const ForwardRefInputControl: React.FC<
  InputControlProps & { ref?: Ref<HTMLInputElement> }
> = InputControl;

/**
 * A small utility component that encapsulates access to a form field's value.
 *
 * This is useful for displaying dynamic content based on a field while avoiding
 * re-rendering the entire form, or needing to create a dedicated component.
 */
export function FieldDerivedValue<T>({
  fieldName,
  children,
}: {
  fieldName: string;
  children: (value: T) => React.ReactNode;
}) {
  const [field] = useField<T>(fieldName);
  return children(field.value);
}
